import { CSSProperties } from "react";
import PDHorizontalLogo from "assets/PD-Logo_Horitzontal1-Color 1.svg?react";
import OldPDLogo from "assets/pd_logo_old.svg?react";
import PDLogo from "assets/pd_logo.svg?react";
import Excel from "assets/microsoft-excel.svg?react";
import Timeline from "assets/timeline.svg?react";
import Lightbulb from "assets/lightbulb_simple.svg?react";
import LightbulbDisabled from "assets/lightbulb_disabled_simple.svg?react";
import Superman from "assets/superman.svg?react";
import BillingReportAsset from "assets/reports/Billing.svg?react";
import CaseReportAsset from "assets/reports/Case.svg?react";
import DocumentIntakeReportAsset from "assets/reports/DocumentIntake.svg?react";
import InventoryPredictionsReportAsset from "assets/reports/InventoryPredictions.svg?react";
import ThroughputReportAsset from "assets/reports/Throughput.svg?react";
import UploadActivityReportAsset from "assets/reports/UploadActivity.svg?react";
import PDLogoBlack from "assets/pd_logo_black.svg?react";
import CollectLogoBlack from "assets/collect_logo_black.svg?react";
import CheckIcon from "@mui/icons-material/Check";
import { SvgIcon } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import Number1Asset from "assets/number_1.svg?react";
import Number2Asset from "assets/number_2.svg?react";
import Number3Asset from "assets/number_3.svg?react";
import clsx from "clsx";
import theme from "theme";

const defaultSize = 32;

export interface IconProps {
  className?: string;
  size?: number;
  htmlColor?: string;
  style?: CSSProperties;
  fill?: string;
}

export const Checkmark = ({ className, size, htmlColor, style }: IconProps) => (
  <CheckIcon
    className={className}
    style={{ ...style, ...{ width: size || defaultSize, height: size || defaultSize } }}
    htmlColor={htmlColor || "green"}
  />
);
export const ExcelIcon = ({ className, size }: IconProps) => (
  <Excel className={className} width={size || defaultSize} height={size || defaultSize} />
);
export const Logo = ({ className, size, style }: IconProps) => (
  <PDLogo className={className} width={size || defaultSize} height={size || defaultSize} style={style} />
);

export const CollectLogo = ({ className, size, style }: IconProps) => (
  <img
    alt="Collect Logo"
    src="/CollectLogo.png"
    className={className}
    width={size || defaultSize}
    height={size || defaultSize}
    style={style}
  />
);

export const CollectBlack = ({ className, size, style, htmlColor }: IconProps) => (
  <CollectLogoBlack
    className={className}
    width={size || defaultSize}
    height={size || defaultSize}
    style={style}
    fill={htmlColor}
  />
);

export const PatternLogoBlack = ({ className, size, style, htmlColor }: IconProps) => (
  <PDLogoBlack
    className={className}
    width={size || defaultSize}
    height={size || defaultSize}
    style={style}
    fill={htmlColor}
  />
);

export const LogoHorizontal = ({ className, size }: IconProps) => (
  <PDHorizontalLogo className={className} width={(size && size * 5) || defaultSize * 5} height={size || defaultSize} />
);

export const OldLogo = ({ className, size }: IconProps) => (
  <OldPDLogo className={className} width={size || defaultSize} height={size || defaultSize} />
);

export const Edit = ({ className, size }: IconProps) => {
  return (
    <EditIcon
      width={size || defaultSize}
      className={clsx(className)}
      fontSize="small"
      sx={{
        color: theme.palette.secondary.main,
      }}
    />
  );
};

export const TimelineIcon = ({ className, size }: IconProps) => (
  <Timeline className={className} width={size || defaultSize} height={size || defaultSize} />
);

export const LightbulbIcon = ({ className, size }: IconProps) => (
  <Lightbulb className={className} width={size || defaultSize} height={size || defaultSize} />
);

export const SupermanIcon = ({ className, size }: IconProps) => (
  <Superman className={className} width={size || defaultSize} height={size || defaultSize} />
);

export const LightbulbDisabledIcon = ({ size, style }: IconProps) => (
  <LightbulbDisabled style={style} width={size || defaultSize} height={size || defaultSize} />
);

export function BillingReport(props): JSX.Element {
  return <SvgIcon {...props} component={BillingReportAsset}></SvgIcon>;
}
export function CaseReport(props): JSX.Element {
  return <SvgIcon {...props} component={CaseReportAsset}></SvgIcon>;
}
export function DocumentIntakeReport(props): JSX.Element {
  return <SvgIcon {...props} component={DocumentIntakeReportAsset}></SvgIcon>;
}
export function InventoryPredictionsReport(props): JSX.Element {
  return <SvgIcon {...props} component={InventoryPredictionsReportAsset}></SvgIcon>;
}
export function ThroughputReport(props): JSX.Element {
  return <SvgIcon {...props} component={ThroughputReportAsset}></SvgIcon>;
}
export function UploadActivityReport(props): JSX.Element {
  return <SvgIcon {...props} component={UploadActivityReportAsset}></SvgIcon>;
}

export function Number1(props): JSX.Element {
  return <SvgIcon {...props} component={Number1Asset}></SvgIcon>;
}
export function Number2(props): JSX.Element {
  return <SvgIcon {...props} component={Number2Asset}></SvgIcon>;
}
export function Number3(props): JSX.Element {
  return <SvgIcon {...props} component={Number3Asset}></SvgIcon>;
}
